import { useState } from 'react';

import { useCurrentUser } from '@/entities/user/currentUser';

import { API } from '@/shared/api';
import { showErrorAlert } from '@/shared/lib/showErrorAlert';

/**
 * Хук для обработки email согласия в TrialProjectProcessing
 * Предоставляет функцию для отправки согласия с обработкой загрузки и ошибок
 */
export const useEmailConsent = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { refetch: getUser } = useCurrentUser();

  /**
   * Отправляет согласие на получение email уведомлений
   */
  const giveEmailConsent = async () => {
    try {
      setIsLoading(true);

      // Обновляем email_consent в профиле пользователя
      await API.updateUser({
        email_consent: true
      });

      // Обновляем данные пользователя
      await getUser();

    } catch (error) {
      showErrorAlert(error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    giveEmailConsent,
    isLoading,
  };
};
